module.exports = __webpack_public_path__ + "img/work4.e28b6a92.png";